export const CONFIG_SERVICE_TOKEN_NAME = "CONFIG_SERVICE";
export const CONFIG_SERVICE_TOKEN = Symbol.for(CONFIG_SERVICE_TOKEN_NAME);

export const CONFIG_SERVICE_ENABLE_PREPROCESSOR = "CONFIG_SERVICE_ENABLE_PREPROCESSOR";
export const CONFIG_SERVICE_ENABLE_PREPROCESSOR_TOKEN = Symbol.for(CONFIG_SERVICE_ENABLE_PREPROCESSOR);

export const CONFIG_ERROR_ATLAS = {
	missingValue: "E_CONFIG_SERVICE_MISSING_VALUE",
	defaultValueRequired: "E_CONFIG_SERVICE_DEFAULT_VALUE_REQUIRED",
	missingTenant: "E_CONFIG_SERVICE_MISSING_TENANT",
	duplicateExperiment: "W_CONFIG_SERVICE_DUPLICATE_EXPERIMENT",
};
